import { render } from "./goodsList.vue?vue&type=template&id=f54e9fd2&scoped=true"
import script from "./goodsList.vue?vue&type=script&lang=js"
export * from "./goodsList.vue?vue&type=script&lang=js"

import "./goodsList.vue?vue&type=style&index=0&id=f54e9fd2&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f54e9fd2"]])

export default __exports__